import { push } from 'react-router-redux';
import routes from 'library/Routes';
import { addSubscription } from 'actions/actions';
import { BLOCKED_STATUS } from 'constants/subscriptionStatus';

interface StoreLike {
  getState: () => { subscription?: { status?: string } | null };
  dispatch: (action: any) => unknown;
}

// What a business tab does on 403 SUBSCRIPTION_BLOCKED (see SubscriptionBlockedHandler.ts): mark the
// subscription blocked and open the "blocked" page - once. When the store already says BLOCKED the user
// is on (or being sent to) the blocked/billing pages, whose own requests may still get this 403; doing
// nothing then is what prevents a redirect loop.
export function createSubscriptionBlockedHandler(store: StoreLike): () => void {
  return () => {
    const subscription = store.getState().subscription;
    if (subscription?.status === BLOCKED_STATUS) {
      return;
    }
    store.dispatch(addSubscription({ ...subscription, status: BLOCKED_STATUS }));
    store.dispatch(push(routes.blocked()));
  };
}
